import { render, staticRenderFns } from "./ProjectMain.vue?vue&type=template&id=0d58e706&scoped=true&"
import script from "./ProjectMain.vue?vue&type=script&lang=js&"
export * from "./ProjectMain.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMain.vue?vue&type=style&index=0&id=0d58e706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58e706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VFlex,VLayout,VProgressCircular})
